<template>
  <li v-if="content.show">
    <p class="text">第<span class="text-label">{{content.order}}</span>:{{content.title}}</p>
    <button @click=sendAToParent(content.num) class="btn-blue">{{content.A}}</button>
    <button @click=sendBToParent(content.num) class="btn-red">{{content.B}}</button>
  </li>
</template>
<script>
export default {
  props:{
    content: Object
  },
  methods:{
    sendAToParent:function(current){
        this.$emit("listenToChildEvent",current,0);
    },
    sendBToParent:function(current){
        this.$emit("listenToChildEvent",current,1);
    }
  }
}
</script>
<style scoped>
  p{
    margin:1.28rem auto 0.64rem auto;
    padding:0.64rem 0.32rem;
    background-color:#00B3DE;
    font-weight:bold;
    color:#ffffff;
    border-radius:10px;
    width: 4.8rem;
    height: 2.5rem;
    font-size: 0.4rem;
  }
  .btn-blue,.btn-red{
    padding:0.48rem 1rem;
  }
</style>